module.exports = __webpack_public_path__ + "img/detail-report.deff5216.png";